<template>
    <div class="container-fluid">
        <div class="row">

            <div class="col-lg-12">
                <div class="card box-margin">

                    <div class="card-header">
                        <i class="fas fa-address-book"></i><span> Clientes</span>

                        <div class="btn-group" role="group">
                            <template v-if="AsignarRolPermisosByUsuario.includes('cliente.crear')">
                                <button type="button" class="btn btn-success" @click="abrirModal"><i class="fas fa-plus-circle"></i> Agregar</button>
                            </template>
                            <template v-if="AsignarRolPermisosByUsuario.includes('cliente.reporte')">
                                <button type="button" class="btn btn-primary"><i class="far fa-file-pdf"></i> Reporte</button>
                            </template>
                        </div>

                    </div>
                    <div class="card-body">

                        <div class="shortcode-html">
                            <!-- Table Bordered -->
                            <div class="form-group row">
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Nombre y apellido</label>
                                            <input type="text" class="form-control" v-model="filtro.nombre_completo"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Número de documento</label>
                                            <input type="text" class="form-control"  v-model="filtro.numero_doc"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                     <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Correo Electronico</label>
                                            <input type="text" class="form-control"  v-model="filtro.correo"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Telefono</label>
                                            <input type="text" class="form-control"  v-model="filtro.telefono"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Actividad Economica</label>
                                            <select class="custom-select"  v-model="filtro.actividad_economica" id="status-select-ac">
                                                <option value="0">Seleccionar</option>
                                                <option v-for="red in aActividadEconomicaList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Referencias</label>
                                            <select class="custom-select" v-model="filtro.referencia" id="status-select-refe">
                                                <option value="0">Seleccionar</option>
                                                <option v-for="red in aReferenciasList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                            </select>
                                        </div>
                                    </div>
                                    <div class="col-md-3" v-if="usuario.rol[0].slug === 'administrador.administrador'">
                                        <div class="form-group">
                                            <label for="status-select" class="mr-2">Asesores</label>
                                            <select class="custom-select" v-model="filtro.id_asesor" id="status-select-id_asesor">
                                                <option value="0">Seleccionar</option>
                                                <option v-for="red in listaAsesores" :key="red.id" :value="red.id" v-text="red.fullname"></option>
                                            </select>
                                        </div>
                                    </div>
                                     <div class="col-md-3">
                                        <div class="form-group">
                                            <label for="LeadName">Nombre y apellido conyugue</label>
                                            <input type="text" class="form-control" v-model="filtro.nombre_conyugue"  placeholder="Buscar ...">
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="LeadName">Buscar</label>
                                             <button type="button" @click="getListCliente(1,pag_mostrar)" class="btn btn-primary form-control"><i class="fas fa-search"></i></button>
                                        </div>
                                    </div>
                                    <div class="col-md-2">
                                        <div class="form-group">
                                            <label for="LeadName">Limpiar</label>
                                             <button type="button" @click="cleanFiltros" class="btn btn-primary form-control"><i class="far fa-trash-alt"></i></button>
                                        </div>
                                    </div>
                            </div>
                            <div class="form-group row">
                                <div class="form-inline col-md-6 col-sm-12">
                                    <div class="form-group col">
                                        <label >Mostrar</label>
                                            <select v-model="pag_mostrar" class="form-control" v-on:change="getListCliente(1,pag_mostrar)">
                                                <option value="5">5</option>
                                                <option value="10">10</option>
                                                <option value="50">50</option>
                                                <option value="100">100</option>
                                            </select>
                                        <label >registros por página</label>
                                    </div>
                                </div>
                            </div>



                            <div  class="table-responsive">

                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th><b>Acciones</b></th>
                                            <th><b>Tipo Aplacamiento</b></th>
                                            <th><b>Nombre</b></th>
                                            <th><b>Apellido</b></th>
                                            <th><b>Documento</b></th>
                                            <th><b>N° de Documento</b></th>
                                            <th><b>Correo Electrónico</b></th>
                                            <th><b>Dirección</b></th>
                                            <th><b>telefono</b></th>
                                            <th><b>F.</b> Nacimiento <b>|</b> Constitucion</th>
                                            <th><b>Referencia</b></th>
                                        </tr>
                                    </thead>

                                    <tbody  v-if="listCliente.length">
                                        <tr v-for="(c, index) in listCliente" :key="index">
                                            <td>
                                                <div class="btn-group mb-2 mr-2">
                                                    <button type="button" class="btn btn-primary dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"><i class="fas fa-filter"></i> Acción</button>
                                                    <div class="dropdown-menu">
                                                        <template v-if="AsignarRolPermisosByUsuario.includes('cliente.editar')">
                                                            <button class="dropdown-item" v-if="c.tipo==1" @click="setObtenerCliente(c.id,false)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                            <button class="dropdown-item" v-if="c.tipo==2" @click="setObtenerCliente2(c,false)"><i class="fa fa-edit text-info" ></i> Editar</button>
                                                        </template>
                                                         <template>
                                                            <button class="dropdown-item"  v-if="c.tipo==1" @click="setObtenerCliente(c.id,true)"><i class="far fa-eye" ></i> Ver</button>
                                                            <button class="dropdown-item" v-if="c.tipo==2" @click="setObtenerCliente2(c,true)"><i class="far fa-eye" ></i> Ver</button>
                                                        </template>

                                                        <template v-if="AsignarRolPermisosByUsuario.includes('cliente.eliminar')">
                                                            <button class="dropdown-item"  @click="setDeleteCliente(c.id)"><i class="fa fa-trash text-danger" ></i> Eliminar</button>
                                                        </template>
                                                    </div>
                                                </div>
                                            </td>
                                            <td >
                                                <span v-if="c.tipo_aplacamiento != 0" v-text="c.tipoaplacamientotext" class="badge badge-success text-white"></span>
                                                <span v-else v-text="c.tipoaplacamientotext" class="badge badge-danger text-white"></span>
                                            </td>
                                            <td   v-if="c.tipo==2" v-text="c.razon_social" colspan="2"></td>
                                            <td  v-if="c.tipo==1" v-text="c.nombre"></td>
                                            <td  v-if="c.tipo==1" v-text="c.apellido"></td>
                                            <td v-text="(c.hasOwnProperty('nombre') && c.documento !=null) ? c.documento.tipo_doc : '' "></td>
                                            <td v-text="c.numdoc"></td>
                                            <td v-text="c.email"></td>
                                            <td v-text="c.direccion"></td>
                                            <td v-text="c.telefono"></td>
                                            <td  v-if="c.tipo==2" v-text="c.fecha_constitucion"></td>
                                            <td  v-if="c.tipo==1" v-text="c.fecha_nacimiento"></td>
                                            <td v-text="(c.hasOwnProperty('nombre') && c.referencia !=null) ? c.referencia.nombre : ''  "></td>

                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td colspan="10" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                                <nav style="float: left;">  Mostrando la página <span v-text="pagination.current_page"></span> de <span v-text="pagination.last_page"></span></nav>
                                <nav style="float: right;">
                                    <ul class="pagination singel-page flex-wrap" >
                                        <li class="page-item" v-if="pagination.current_page > 1">
                                            <a class="page-link" @click.prevent="cambiarPagina(pagination.current_page - 1)" href="#">Anterior</a>
                                        </li>
                                        <li class="page-item" v-for="page in pagesNumber" :key="page" :class="[page == isActived ? 'active' : '']">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(page)" v-text="page"></a>
                                        </li>
                                        <li class="page-item" v-if="pagination.current_page < pagination.last_page">
                                            <a class="page-link" href="#"  @click.prevent="cambiarPagina(pagination.current_page + 1)">Siguiente</a>
                                        </li>
                                    </ul>
                                </nav>


                            <!-- End Table Bordered -->
                        </div>

                    </div>
                </div>
            </div>


        </div>

        <!--   Inicio modal Usuario-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShowNatural }" :style=" modalShowNatural ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal"></h5>
                        <button type="button" @click="abrirModalNatural" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                       <form :class="(detalle ===true) ?  'bloquear' : ''">
                           <div class="row">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name" v-model="vaCreCliente.cNombre" placeholder="Ingresa Nombre del Cliente" >
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido" v-model="vaCreCliente.cApellido" placeholder="Ingresa Apellido del Cliente">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Documento</label>
                                        <select class="custom-select" @change="consultarDatos()" v-model="vaCreCliente.eIdDocumento" id="status-select">
                                            <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="usuarios">N° Documento</label>
                                        <input type="text"  @input="" @keyup.enter="consultarCedula()"   style="background: aliceblue;" class="form-control" :disabled="bloquar_input_natural" v-model="vaCreCliente.cNumDoc" placeholder="Ingrese número de documento">
                                        <label id="cname-error" class="error mt-2 text-danger" for="cname" v-if="document.estado" v-text="document.error"></label>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Genero</label>
                                        <select class="custom-select" v-model="vaCreCliente.genero" id="status-select">
                                            <option value="Masculino" v-text="'Masculino'"></option>
                                            <option value="Femenino" v-text="'Femenino'"></option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Dirección</label>
                                        <input type="text" class="form-control" id="direccion" v-model="vaCreCliente.cDireccion" placeholder="Ingrese una Dirección">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Correo Electrónico</label>
                                        <input type="text" class="form-control" id="correo" v-model="vaCreCliente.cEmail" placeholder="Ingresa un Correo Electrónico">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Teléfono </label>
                                        <input type="text" class="form-control" v-model="vaCreCliente.cTelefonoCliente" placeholder="Ingrese un Nº de Teléfono">
                                    </div>
                                </div>

                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="vaCreCliente.fecha_nacimiento" >
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Referencias</label>
                                        <select class="custom-select" v-model="vaCreCliente.referencia" id="status-select">
                                            <option v-for="red in aReferenciasList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Actividad Economica</label>
                                        <select class="custom-select" v-model="vaCreCliente.idactividad_economica" id="status-select">
                                            <option v-for="red in aActividadEconomicaList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                        </select>
                                    </div>
                                </div>
                                   <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="tipo_negocio">Tipo Aplacamiento</label>
                                        <select class="custom-select" v-model="vaCreCliente.tipo_aplacamiento">
                                            <option  value="0">Seleccionar</option>
                                            <option  value="1">Natural</option>
                                            <option  value="2">Consorcio</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre Conyugue</label>
                                        <input type="text" class="form-control" id="name_conyugue" v-model="vaCreCliente.nombre_conyugue" placeholder="Ingresa Nombre del Conyugue">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido Conyugue</label>
                                        <input type="text" class="form-control" id="apellido_conyugue" v-model="vaCreCliente.apellido_conyugue" placeholder="Ingresa Apellido del Conyugue">
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Estado Civil</label>
                                        <select class="custom-select" v-model="vaCreCliente.estado_civil" id="status-select">

                                            <option value="Soltero">Soltero</option>
                                            <option value="Casado">Casado</option>
                                            <option value="Divorciado">Divorciado</option>
                                            <option value="Unión libre">Unión libre</option>

                                        </select>
                                    </div>
                                </div>
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                        <input type="date" class="form-control" v-model="vaCreCliente.fecha_nacimiento_conyugue" >
                                    </div>
                                </div>
                                <div class="col-md-2">
                                    <div class="form-group">
                                        <label for="LeadName">Cantidad de Hijos</label>
                                        <input type="text" class="form-control" v-if="detalle ===true" id="hijos" v-model="vaCreCliente.hijos_cantidad">
                                        <input type="number" v-else min="0" class="form-control" id="hijos" v-model="vaCreCliente.hijos_cantidad">
                                    </div>
                                </div>

                                <div class="col-md-2 bloquear">
                                    <div class="form-group">
                                        <label for="LeadName">Edad Conyugue</label>
                                        <input type="text" class="form-control" id="edad_conyugue" :value="calcularEdad(vaCreCliente.fecha_nacimiento_conyugue)">
                                    </div>
                                </div>

                            </div>
                        </form>

                        <form class="g-brd-around g-brd-gray-light-v4">
                             <h4>Nombre de los Hijos</h4>
                            <hr class="g-brd-gray-light-v4 g-mx-minus-30">
                            <div class="row" v-if="detalle ===false">
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name_hijo" v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido_hijo" v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="dataHijosConyugues.fecha_nacimiento" >
                                    </div>
                                </div>
                                 <div class="col-md-12 text-right">
                                   <button type="button" class="btn btn-success mb-2 mr-2" @click="agregarHijosConyugue()">Agregar</button>
                                </div>
                            </div>
                            <div class="table-responsive" style="padding-top: 10ox">
                                <table class="table table-bordered" :class="(detalle ===true) ?  'bloquear' : ''">
                                    <thead>
                                        <tr>
                                            <th v-if="detalle ===false">Eliminar</th>
                                            <th>Nombre</th>
                                            <th>Apellido</th>
                                            <th>Cumpleaños</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="listHijosConyugue.length">
                                        <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                            <td v-if="detalle ===false">
                                                <button type="button" @click="eliminar_hijo(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button>
                                            </td>
                                            <td >
                                                <input type="text" class="form-control" v-model="c.nombre" placeholder="Ingresar Nombre">
                                            </td>
                                            <td>
                                                 <input type="text" class="form-control" v-model="c.apellido" placeholder="Ingresar Apellido">
                                            </td>
                                            <td >
                                                 <input type="date" class="form-control" v-model="c.cumpleanio" >
                                            </td>
                                            <td>{{calcularEdad(c.cumpleanio)}} Años</td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td :colspan="(detalle ===false) ? 10 : 9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </form>
                    </div>

                     <div class="modal-footer">
                            <button type="button" v-if="actu_reg==0 " class="btn btn-sm btn-primary" @click="setRegistrarCliente" v-text="nameButon"></button>
                            <button type="button" v-if="actu_reg==1 && detalle ===false" class="btn btn-sm btn-primary" @click="setActualizarCliente" v-text="nameButon"></button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalNatural">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal Usuario-------------------------------------------------------------->
         <!--   Inicio modal tipo-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShow }" :style=" modalShow ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-md modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" >Seleccionar Tipo de Registro</h4>
                        <button type="button" @click="abrirModal" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-md-12 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrirModalNatural(),abrirModal()">Natural</button>
                            </div>
                            <!-- <div class="col-md-6 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrilModalImpotarExcelNatural(),abrirModal()"><i class="fas fa-file-excel"></i> Natural-Excel</button>
                            </div> -->
                            <div class="col-md-12 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrirModalJuridica(),abrirModal()">Juridico</button>
                            </div>
                            <!-- <div class="col-md-6 form-group">
                                <button type="button" class="btn btn-primary  btn-block" @click="abrilModalImpotarExcelJuridico(),abrirModal()"><i class="fas fa-file-excel"></i> Juridico-Excel</button>
                            </div> -->
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModal">Cerrar</button>
                    </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal tipo-------------------------------------------------------------->

         <!--   Inicio modal jurudica-------------------------------------------------------------->
        <div class="modal fade " :class="{ show: modalShowJuridica }" :style=" modalShowJuridica ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h4 class="modal-title mt-0 font-16" id="myLargeModalLabel" v-text="tituloModal_juri"></h4>
                        <button type="button" @click="abrirModalJuridica()" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">
                        <h5>Datos Generales</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" :class="(detalle_2 ===true) ?  'bloquear' : ''">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Razón Social</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_cliente_juridico.razon_social" placeholder="Ingresar razón social">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Ruc</label>
                                    <input type="text" style="background: aliceblue;" @input="consultarDatos()" :disabled="bloquar_input_natural" class="form-control" id="name" v-model="crear_cliente_juridico.ruc" placeholder="Ingresar ruc">
                                    <label id="cname-error" class="error mt-2 text-danger" for="cname" v-if="document.estado" v-text="document.error"></label>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Documento</label>
                                    <select class="custom-select" @change="consultarDatos()"  v-model="crear_cliente_juridico.id_documento" id="status-select">
                                         <option value="0">Seleccionar</option>
                                        <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Dirección</label>
                                    <input type="text" class="form-control" id="direccion" v-model="crear_cliente_juridico.direccion" placeholder="Ingrese una dirección">
                                </div>
                            </div>
                             <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="status-select" class="mr-2">Genero</label>
                                        <select class="custom-select" v-model="crear_cliente_juridico.genero" id="status-select">
                                            <option value="Masculino" v-text="'Masculino'"></option>
                                            <option value="Femenino" v-text="'Femenino'"></option>
                                        </select>
                                    </div>
                                </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Correo Electrónico</label>
                                    <input type="text" class="form-control" id="correo" v-model="crear_cliente_juridico.correo" placeholder="Ingrese un correo electrónico">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 1</label>
                                    <input type="text" class="form-control" v-model="crear_cliente_juridico.telefono_1" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 2</label>
                                    <input type="text" class="form-control" v-model="crear_cliente_juridico.telefono_2" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha de Constitución</label>
                                    <input type="date" class="form-control" v-model="crear_cliente_juridico.fecha_constitucion" >
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Actividad Economica</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_actividad_economica" id="status-select">

                                        <option v-for="red in aActividadEconomicaList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Referencia</label>
                                    <select class="custom-select" v-model="crear_cliente_juridico.id_referencia" id="status-select">

                                        <option v-for="red in aReferenciasList" :key="red.id" :value="red.id" v-text="red.nombre"></option>
                                    </select>
                                </div>
                            </div>

                             <div class="col-md-4 col-sm-4 col-lg-4">
                                    <div class="form-group">
                                        <label for="tipo_negocio">Tipo Aplacamiento</label>
                                        <select class="custom-select" v-model="crear_cliente_juridico.tipo_aplacamiento">
                                            <option  value="0">Seleccionar</option>
                                            <option  value="1">Natural</option>
                                            <option  value="2">Consorcio</option>
                                        </select>
                                    </div>
                                </div>

                        </div>
                        <h5>Datos del Representante Legal</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" :class="(detalle_2 ===true) ?  'bloquear' : ''">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Nombre</label>
                                    <input type="text" class="form-control" id="name" v-model="crear_representante_legal.nombre" placeholder="Ingrese nombre">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Apellido</label>
                                    <input type="text" class="form-control" id="apellido" v-model="crear_representante_legal.apellido" placeholder="Ingrese apellido">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Documento</label>
                                    <select class="custom-select" v-model="crear_representante_legal.id_documento" id="status-select_2">

                                        <option v-for="doc in aTipoDocumento" :key="doc.id" :value="doc.id" v-text="doc.tipo_doc"></option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Número de documento</label>
                                    <input type="text" class="form-control" id="apellido" v-model="crear_representante_legal.documento" placeholder="Ingrese apellido">
                                </div>
                            </div>

                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Dirección</label>
                                    <input type="text" class="form-control" id="direccion" v-model="crear_representante_legal.direccion" placeholder="Ingrese una dirección">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Correo Electrónico</label>
                                    <input type="text" class="form-control" id="correo" v-model="crear_representante_legal.correo" placeholder="Ingrese un correo electrónico">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 1</label>
                                    <input type="text" class="form-control" v-model="crear_representante_legal.telefono_1" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Teléfono 2</label>
                                    <input type="text" class="form-control" v-model="crear_representante_legal.telefono_2" placeholder="Ingrese un Nº de Teléfono">
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha de Nacimiento</label>
                                    <input type="date" class="form-control" v-model="crear_representante_legal.fecha_nacimiento" >
                                </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="status-select" class="mr-2">Estado Civil</label>
                                    <select class="custom-select" v-model="crear_representante_legal.estado_civil" id="status-select_3">
                                        <option value="Soltero">Soltero</option>
                                        <option value="Casado">Casado</option>
                                        <option value="Divorciado">Divorciado</option>
                                        <option value="Unión libre">Unión libre</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <h5>Datos del Cónyuge</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" :class="(detalle_2 ===true) ?  'bloquear' : ''">
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Nombre Conyugue</label>
                                    <input type="text" class="form-control" id="name_conyugue" v-model="crear_cliente_juridico.nombre_conyugue" placeholder="Ingresa Nombre del Conyugue">
                                </div>
                            </div>
                            <div class="col-md-4">
                               <div class="form-group">
                                   <label for="LeadName">Apellido Conyugue</label>
                                   <input type="text" class="form-control" id="apellido_conyugue" v-model="crear_cliente_juridico.apellido_conyugue" placeholder="Ingresa Apellido del Conyugue">
                               </div>
                            </div>
                            <div class="col-md-4">
                                <div class="form-group">
                                    <label for="LeadName">Fecha Nacimiento Conyugue</label>
                                    <input type="date" class="form-control" v-model="crear_cliente_juridico.fecha_nacimiento_conyugue" >
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group">
                                    <label for="LeadName">Cantidad de Hijos</label>
                                    <input type="number"  min="0" class="form-control" id="hijos" v-model="crear_cliente_juridico.hijos_cantidad">
                                </div>
                            </div>
                            <div class="col-md-2 bloquear">
                                <div class="form-group">
                                    <label for="LeadName">Edad Conyugue</label>
                                    <input type="text" class="form-control" id="edad_conyugue" :value="calcularEdad(crear_cliente_juridico.fecha_nacimiento_conyugue)">
                                </div>
                            </div>
                        </div>

                        <h5>Nombre de los Hijos</h5>
                        <hr class="g-brd-gray-light-v4 g-mx-minus-0">
                        <div class="row" v-if="detalle_2 ===false" >
                                <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Nombre</label>
                                        <input type="text" class="form-control" id="name_hijo" v-model="dataHijosConyugues.nombre" placeholder="Ingresar Nombre">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Apellido</label>
                                        <input type="text" class="form-control" id="apellido_hijo" v-model="dataHijosConyugues.apellido" placeholder="Ingresar Apellido">
                                    </div>
                                </div>
                                 <div class="col-md-4">
                                    <div class="form-group">
                                        <label for="LeadName">Fecha Nacimiento </label>
                                        <input type="date" class="form-control" v-model="dataHijosConyugues.fecha_nacimiento" >
                                    </div>
                                </div>
                                 <div class="col-md-12 text-right">
                                   <button type="button" class="btn btn-success mb-2 mr-2" @click="agregarHijosConyugue()">Agregar</button>
                                </div>
                        </div>
                        <div class="table-responsive" style="padding-top: 10ox">
                                <table class="table table-bordered" :class="(detalle_2 ===true) ?  'bloquear' : ''">
                                    <thead>
                                        <tr>
                                            <th v-if="detalle_2 ===false">Eliminar</th>
                                            <th>Nombre</th>
                                            <th>Apellido</th>
                                            <th>Cumpleaños</th>
                                            <th>Edad</th>
                                        </tr>
                                    </thead>

                                    <tbody v-if="listHijosConyugue.length">
                                        <tr v-for="(c, index) in listHijosConyugue" :key="index">
                                            <td v-if="detalle_2 ===false">
                                                <button type="button" @click="eliminar_hijo(index)" class="btn btn-danger btn-block"><i class="fas fa-trash-alt"></i> Quitar</button>
                                            </td>
                                            <td >
                                                <input type="text" class="form-control" v-model="c.nombre" placeholder="Ingresar Nombre">
                                            </td>
                                            <td>
                                                 <input type="text" class="form-control" v-model="c.apellido" placeholder="Ingresar Apellido">
                                            </td>
                                            <td >
                                                 <input type="date" class="form-control" v-model="c.cumpleanio" >
                                            </td>
                                            <td>{{calcularEdad(c.cumpleanio)}} Años</td>
                                        </tr>
                                    </tbody>
                                     <tbody v-else>
                                        <tr>
                                            <td :colspan="(detalle_2 ===false) ? 10 : 9" align="center">
                                                <h5>No se encontraron resultados...</h5>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                        </div>

                    </div>

                    <div class="modal-footer">
                        <button type="button" v-if="actu_reg_juri==0 && detalle_2 ===false" class="btn btn-sm btn-primary" @click="setRegistrarClienteJuridico" >Guardar</button>
                        <button type="button" v-if="actu_reg_juri==1 && detalle_2 ===false" class="btn btn-sm btn-primary" @click="setRegistrarClienteJuridico" >Actualizar</button>
                        <button type="button" class="btn btn-sm btn-secondary" @click="abrirModalJuridica()">Cerrar</button>
                    </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
        </div>
        <!--   Fin modal jurudica-------------------------------------------------------------->

         <!------excel ----------------------------------------------------------------------------------------->

    <div class="modal fade " :class="{ show: modalShowExcel }" :style=" modalShowExcel ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16"  >Importar Clientes Naturales - Excel</h5>
                        <button type="button" @click="abrilModalImpotarExcelNatural()" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName">Archivo Excel</label>
                                    <input  vue-load-file @change="fileUploadeExcel"  class="form-control"  type="file" id="file"  accept=".XLSX" >

                                </div>
                            </div>
                             <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName" class="text-danger"><b>Nota*</b></label>
                                    <p>- Solo se permiten archivos Excel de formato <b>.xlsx</b>, Click <a href="/excel/cliente-natural.xlsx" download>aquÍ</a> para descargar
                                    archivo modelo.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="modal-footer">
                            <button type="button"  @click="importarExcelNatural()" class="btn btn-sm btn-primary" >Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrilModalImpotarExcelNatural()">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
    </div>

    <div class="modal fade " :class="{ show: modalShowExcelJuridico }" :style=" modalShowExcelJuridico ? mostrarModal : 'ocultarModal'" >
            <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title mt-0 font-16"  >Importar Clientes Juridicos - Excel</h5>
                        <button type="button" @click="abrilModalImpotarExcelJuridico()" class="close" data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div class="modal-body">

                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName">Archivo Excel</label>
                                    <input  vue-load-file @change="fileUploadeExcelJuridico"  class="form-control"  type="file" id="file_juridico"  accept=".XLSX" >

                                </div>
                            </div>
                             <div class="col-md-12">
                                <div class="form-group">
                                    <label for="LeadName" class="text-danger"><b>Nota*</b></label>
                                    <p>- Solo se permiten archivos Excel de formato <b>.xlsx</b>, Click <a href="/excel/cliente-juridico.xlsx" download>aquÍ</a> para descargar
                                    archivo modelo.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                     <div class="modal-footer">
                            <button type="button"  @click="importarExcelJuridico()" class="btn btn-sm btn-primary" >Guardar</button>
                            <button type="button" class="btn btn-sm btn-secondary" @click="abrilModalImpotarExcelJuridico()">Cerrar</button>
                     </div>

                </div><!-- /.modal-content -->
            </div><!-- /.modal-dialog -->
    </div>

    </div>
</template>

<script>

import {alertasM} from '../../../util.js';

export default {
    props: ['ruta','usuario'],
    data() {
        return {
            lista_cedula: [],
            loading: false,
            ciudadano: null,
            cCriterio: 'nombre',
            filtro: {
                nombre_completo : '',
                numero_doc : '',
                correo : '',
                telefono: '',
                actividad_economica : 0,
                referencia: 0,
                nombre_conyugue: '',
                id_asesor: 0
            },
            listCliente: [],
            aTipoDocumento: [],
            aReferenciasList: [],
            aActividadEconomicaList: [],
            excel_natural : '',
            excel_juridico : '',
            pagination : {
                    'total' : 0,
                    'current_page' : 0,
                    'per_page' : 0,
                    'last_page' : 0,
                    'from' : 0,
                    'to' : 0,
                },
            offset: 3,
            pag_mostrar: 5,//registros a mostrar por pagina tipo datable
            modalShow: false,
            modalShowNatural: false,
            modalShowJuridica: false,
            modalShowExcel: false,
            modalShowExcelJuridico: false,
            mostrarModal: {
                display: 'block',
                background: '#0000006b'
            },
            ocultarModal: {
                display: 'none'
            },
            vaCreCliente:{
                eId: 0,
                cNombre: '',
                cApellido: '',
                fecha_nacimiento: null,
                cNumDoc: '',
                eIdDocumento: 1,
                cDireccion: '',
                cTelefonoCliente: '',
                cEmail: '',
                referencia: 0,
                idactividad_economica: 0,
                estado_civil: '',
                hijos_cantidad: 0 ,
                nombre_conyugue: '',
                apellido_conyugue: '',
                fecha_nacimiento_conyugue: null,
                tipo                      : 1,
                tipo_aplacamiento       : 0,
                genero : 'Masculino'
            },

            crear_cliente_juridico:{
                id                          : 0,
                razon_social                : '',
                ruc                         : '',
                direccion                   : '',
                correo                      : '',
                id_documento                : 3,
                telefono_1                  : '',
                telefono_2                  : '',
                fecha_constitucion          : null,
                id_actividad_economica      : 0,
                id_referencia               : 0,
                tipo                        : 2,
                tipo_aplacamiento           : 0,
                nombre_conyugue             : '',
                apellido_conyugue           : '',
                fecha_nacimiento_conyugue   : null,
                hijos_cantidad              : 0,
                genero: 'Masculino'
            },
            crear_representante_legal: {
                id                  : '',
                nombre              : '',
                apellido            : '',
                documento           : '',
                id_documento        : 0,
                direccion           : '',
                correo              : '',
                telefono_1          : '',
                telefono_2          : '',
                fecha_nacimiento    : null,
                estado_civil        : '',

            },
            tituloModal_juri: '',
            nameButon_juri: '',
            actu_reg_juri: 0, //0 registrar - 1 actualizar
            tituloModal: '',
            nameButon: '',
            actu_reg: 0, //0 registrar - 1 actualizar
            AsignarRolPermisosByUsuario: JSON.parse(localStorage.getItem('listRolPermisosByUsuario')),

            dataHijosConyugues:{
                id: 0,
                nombre: '',
                apellido: '',
                fecha_nacimiento: null
            },
            listHijosConyugue: [],
            detalle : false,
            detalle_2 : false,
            listaAsesores: [],
            uploadPercentage: 0,
            bloquar_input_natural: false,
            document: {
                error : '',
                estado : false,
            }

        }
    },
    mixins: [alertasM],
    computed: {
            isActived: function() {
                return this.pagination.current_page;
            },
            //Calcula los elementos de la paginación
            pagesNumber: function() {
                if (!this.pagination.to) {
                    //si la pagina es diferente al ultimo elemento de la pagina actual, retornamos
                    return []; //Array vacio
                }

                var from = this.pagination.current_page - this.offset;
               // console.log("bengy: ", from);
                if (from < 1) {
                    //si la pagina actual es 0 entonces la igualamos  a uno
                    from = 1;
                }
                //la suma de la variable rom + el doble de la varialbe offset
                var to = from + this.offset * 2;
               // console.log("bengy2: ", from);
                if (to >= this.pagination.last_page) {
                    to = this.pagination.last_page;
                }

                var pagesArray = [];
                while (from <= to) {
                    /*   pagesArray.push(from);//Ocurre desbordamiento, cuando son muchos registros
                                from++; */
                    //Solucion
                    if (
                        (from >= this.pagination.current_page - 1) &
                        (from <= this.pagination.current_page + 3)
                    )
                        pagesArray.push(from);
                    from++;
                }
                return pagesArray;
            },
        },
    methods: {


        verificarCedulaRegistro()
        {

              if (this.vaCreCliente.cNumDoc.length == 0) {
                this.notify("La cédula debe tener exactamente 10 dígitos", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                return;

            }

             let url = '/cedula/existeCedula';
            axios.get(url, { params: { cedula: this.vaCreCliente.cNumDoc } })
            .then(response => {
                this.lista_cedula = response.data;

                console.log("lista de cedula es :"+this.lista_cedula[0].numero);

                let cedula =parseInt(this.lista_cedula[0].numero);

                if (cedula>=1)
                {

                this.notify("La cédula ya se encuentra Registrada en el Módulo de Clientes", "", "top", "center", "fas fa-exclamation-triangle", "danger");
                return;

                }



            }).catch(error => {
                console.error("Error obteniendo renovaciones", error);
            });




        },


          consultarCedula() {
            if (this.vaCreCliente.cNumDoc.length <= 9) {
                this.notify("La cédula debe tener exactamente 10 dígitos", "", "top", "center", "fas fa-exclamation-triangle", "warning");
                return;

            }
             if(this.vaCreCliente.cNumDoc.length >= 13)
                {
                    return;
                }

            this.loading = true;
            this.ciudadano = null;

            axios.get('/cedula/consultar', { params: { cedula: this.vaCreCliente.cNumDoc } })
                .then(res => {
                    if (res.data.success) {
                        //this.ciudadano = res.data.data;

                        //vaCreCliente.cApellido
                        //this.vaCreCliente.cNombre = res.data.data.nombre_completo;
                        const nombreCompleto = res.data.data.nombre_completo; // "ROBLES ALMEIDA JORGE WILLIAM"

                        // 1. Convertimos la cadena en un array separando por espacios
                        const palabras = nombreCompleto.split(' ').filter(p => p.trim() !== '');

                        if (palabras.length >= 4) {
                            // Caso estándar: 2 apellidos y 2 nombres (o más)
                            // Tomamos las 2 primeras palabras para los apellidos
                            this.vaCreCliente.cApellido = palabras.slice(0, 2).join(' '); // "ROBLES ALMEIDA"
                            // Tomamos todo el resto para los nombres
                            this.vaCreCliente.cNombre = palabras.slice(2).join(' ');    // "JORGE WILLIAM"
                        } else if (palabras.length === 3) {
                            // Caso de 1 apellido y 2 nombres, o 2 apellidos y 1 nombre
                            // Por estándar de la ANT, dejamos la primera palabra como Apellido y el resto como Nombres
                            this.vaCreCliente.cApellido = palabras[0];
                            this.vaCreCliente.cNombre = palabras.slice(1).join(' ');
                        } else if (palabras.length === 2) {
                            // Caso extremo: 1 apellido y 1 nombre
                            this.vaCreCliente.cApellido = palabras[0];
                            this.vaCreCliente.cNombre = palabras[1];
                        } else {
                            // Si solo viene una palabra (contingencia)
                            this.vaCreCliente.cNombre = nombreCompleto;
                            this.vaCreCliente.cApellido = '';
                        }
                        this.verificarCedulaRegistro();

                    }
                })
                .catch(err => {
                    let msg = "Error al conectar con la consulta civil.";
                    if (err.response && err.response.data) {
                        msg = err.response.data.message;
                    }
                    this.notify(msg, "", "top", "center", "fas fa-times", "danger");
                })
                .finally(() => { this.loading = false; });
        },

        getListCliente(page,pag_mostrar){

          var url = '/cliente';
          this.openCargando();//Activamos pantalla de carga de bloqueo
          axios.get(url,{
              params:{
                  'filtro': JSON.stringify(this.filtro),
                  'page' : page,
                  'pag_mostrar': pag_mostrar
              }
          })
          .then(res => {

                var respuesta = res.data;
                this.listCliente = respuesta.cliente.data;
                this.pagination = respuesta.pagination;
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })
          .catch(err => {
             if (err.response.status == 401) {
                    if (localStorage['authUser']) {
                         this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                    }
              console.error(err);
             this.openCargando(true);//Desactivamos ventana de carga de bloqueo
          })

        },

        cleanFiltros(){
            this.filtro.nombre_completo  =  '';
            this.filtro.numero_doc  =  '';
            this.filtro.correo  =  '';
            this.filtro.telefono =  '';
            this.filtro.actividad_economica  =  0;
            this.filtro.id_asesor  =  0;
            this.filtro.referencia =  0;
            this.filtro.nombre_conyugue =  '';
            this.getListCliente(1,this.pag_mostrar);
        },
        //Trae los tipos de documentos para un select
        getSelectTipoDoc(){

            var url = '/administracion/usuario/getListarDocumentos';

            axios.get(url)
            .then(res => {

                var respuesta = res.data;
                this.aTipoDocumento = respuesta.documento;
                this.aReferenciasList = respuesta.referencia;
                this.listaAsesores = respuesta.users;
                this.aActividadEconomicaList = respuesta.actividadeconomica;
                //console.log(respuesta.documento);

            })
            .catch(err => {

                console.error(err);
                 if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
            })
        },

        cambiarPagina(page) {
                let me = this;
                //Actualiza la página actual
                me.pagination.current_page = page;
                //Envia la petición para visualizar la data de esa página
                me.getListCliente(page,me.pag_mostrar);
        },

        abrirModalNatural() {
            this.modalShowNatural = !this.modalShowNatural;

            if(this.modalShowNatural==true){

                this.tituloModal = "Registrar Cliente Natural";
                this.actu_reg = 0;
                this.nameButon = "Guardar";

            }else{

                this.detalle = false;
                this.cleanVariables();
            }
        },

        abrirModalJuridica() {
            this.modalShowJuridica = !this.modalShowJuridica;

            if(this.modalShowJuridica==true){

                this.tituloModal_juri = "Registrar Cliente Juridico";
                this.actu_reg_juri = 0;

            }else{
                this.detalle_2 = false;
                this.cleanVariables();
                this.clearVariablesJuridico();//Limpiamos el form
            }
        },

        cleanVariables(){
            this.vaCreCliente.cNombre = "";
            this.vaCreCliente.tipo_aplacamiento = 0;
            this.vaCreCliente.referencia = "";
            this.vaCreCliente.cApellido = "";
            this.vaCreCliente.fecha_nacimiento = "";
            this.vaCreCliente.eId = "";
            this.vaCreCliente.cNumDoc = "";
            this.vaCreCliente.eIdDocumento = 1;
            this.vaCreCliente.referencia = 1;
            this.vaCreCliente.cDireccion = "";
            this.vaCreCliente.cTelefonoCliente = "";
            this.vaCreCliente.cEmail = "";
            this.vaCreCliente.idactividad_economica = 0;
            this.vaCreCliente.estado_civil = '';
            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0 ;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
            this.vaCreCliente.genero = 'Masculino';

        },

        setRegistrarCliente(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/cliente/registrar';

            axios.post(url, {
                'nombre' :                  this.vaCreCliente.cNombre,
                'tipo_aplacamiento' :       this.vaCreCliente.tipo_aplacamiento,
                'referencia' :              this.vaCreCliente.referencia,
                'apellido' :                this.vaCreCliente.cApellido,
                'documento':                this.vaCreCliente.eIdDocumento,
                'idreferencia':             this.vaCreCliente.referencia,
                'numdoc':                   this.vaCreCliente.cNumDoc,
                'direccion':                this.vaCreCliente.cDireccion,
                'telefono':                 this.vaCreCliente.cTelefonoCliente,
                'fecha_nacimiento':         this.vaCreCliente.fecha_nacimiento,
                'email':                    this.vaCreCliente.cEmail,
                'idactividad_economica':    this.vaCreCliente.idactividad_economica,
                'estado_civil':             this.vaCreCliente.estado_civil,
                'hijos_cantidad':           this.vaCreCliente.hijos_cantidad,
                'nombre_conyugue':          this.vaCreCliente.nombre_conyugue,
                'apellido_conyugue':        this.vaCreCliente.apellido_conyugue,
                'fecha_nacimiento_conyugue': this.vaCreCliente.fecha_nacimiento_conyugue,
                'genero': this.vaCreCliente.genero,
                'arrayHijosConyugue' :      this.listHijosConyugue
            }).then(res => {

                if(res.data.status){

                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.cleanVariables();//Limpiamos el form
                    this.getListCliente(1,this.pag_mostrar);
                    this.notify(" Cliente registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')

                }else if(res.data.errorTipo) {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.notify(" Seleccione almenos un tipo de cliente","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        setRegistrarClienteJuridico(){

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/cliente/registrar-juridico';
            let me = this;

            axios.post(url, {
                'datos_general'         : me.crear_cliente_juridico,
                'representante_legal'   : me.crear_representante_legal,
                'hijos'                 : me.listHijosConyugue,
            }).then(res => {

                if(res.data.status){

                   this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                   this.clearVariablesJuridico();//Limpiamos el form
                   this.getListCliente(1,this.pag_mostrar);
                   this.abrirModalJuridica();
                  if(this.actu_reg==1){
                       this.notify(" Cliente registrado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                  }else{
                       this.notify(" Cliente actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                  }

                }else{
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.notify("Error","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }

            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        setActualizarCliente(){
            //console.log(this.pagination.current_page);
            //return

            this.openCargando();//Activamos ventana de carga de bloqueo
            var url = '/cliente/actualizar';

             axios.post(url, {
                'id'                        : this.vaCreCliente.eId,
                'tipo_aplacamiento'                    : this.vaCreCliente.tipo_aplacamiento,
                'nombre'                    : this.vaCreCliente.cNombre,
                'referencia'                : this.vaCreCliente.referencia,
                'apellido'                  : this.vaCreCliente.cApellido,
                'documento'                 : this.vaCreCliente.eIdDocumento,
                'idreferencia'              : this.vaCreCliente.referencia,
                'numdoc'                    : this.vaCreCliente.cNumDoc,
                'direccion'                 : this.vaCreCliente.cDireccion,
                'telefono'                  : this.vaCreCliente.cTelefonoCliente,
                'fecha_nacimiento'          : this.vaCreCliente.fecha_nacimiento,
                'email'                     : this.vaCreCliente.cEmail,
                'idactividad_economica'     : this.vaCreCliente.idactividad_economica,
                'estado_civil'              : this.vaCreCliente.estado_civil,
                'hijos_cantidad'            : this.vaCreCliente.hijos_cantidad,
                'nombre_conyugue'           : this.vaCreCliente.nombre_conyugue,
                'apellido_conyugue'         : this.vaCreCliente.apellido_conyugue,
                'fecha_nacimiento_conyugue' : this.vaCreCliente.fecha_nacimiento_conyugue,
                'genero' : this.vaCreCliente.genero,
                'arrayHijosConyugue'        : this.listHijosConyugue
            }).then(res => {


                this.cleanVariables();//Limpiamos el form
                //this.openCargando(true);//Desactivamos ventana de carga de bloqueo

                //this.getListCliente(this.pagination.current_page,this.pag_mostrar);
                this.modalShow=false;

                if(res.data.status){
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.cleanVariables();//Limpiamos el form
                    this.getListCliente(this.pagination.current_page,this.pag_mostrar);
                    this.notify(" Cliente actualizado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')

                }else if(res.data.errorTipo) {
                    this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    this.notify(" Seleccione almenos un tipo de cliente","","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
                }
            })
            .catch(err => {
                this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){

                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })
        },

        setObtenerCliente(id,bloquear){
            this.getSelectTipoDoc();
            let me = this;
            me.openCargando();
            var url = '/cliente/detalle';
            axios.post(url,{'id': id})
             .then(res => {

                var respuesta = res.data;

                this.tituloModal = "Actualizar Cliente";
                this.nameButon = "Actualizar"

                this.vaCreCliente.cNombre = respuesta.cliente.nombre;
                this.vaCreCliente.genero = respuesta.cliente.genero;
                this.vaCreCliente.tipo_aplacamiento = respuesta.cliente.tipo_aplacamiento;
                this.vaCreCliente.cApellido = respuesta.cliente.apellido;
                this.vaCreCliente.referencia = respuesta.cliente.referencia;
                this.vaCreCliente.eId = respuesta.cliente.id;
                this.vaCreCliente.cNumDoc = respuesta.cliente.numdoc;
                this.vaCreCliente.eIdDocumento = respuesta.cliente.iddocumento;
                this.vaCreCliente.referencia = respuesta.cliente.idreferencia;
                this.vaCreCliente.cDireccion = respuesta.cliente.direccion;
                this.vaCreCliente.cTelefonoCliente = respuesta.cliente.telefono;
                this.vaCreCliente.cEmail = respuesta.cliente.email;
                this.vaCreCliente.fecha_nacimiento = respuesta.cliente.fecha_nacimiento;
                this.vaCreCliente.idactividad_economica = respuesta.cliente.idactividad_economica;
                this.vaCreCliente.estado_civil = respuesta.cliente.estado_civil;
                this.vaCreCliente.hijos_cantidad = respuesta.cliente.hijos_cantidad;
                this.vaCreCliente.nombre_conyugue = respuesta.cliente.nombre_conyugue;
                this.vaCreCliente.apellido_conyugue = respuesta.cliente.apellido_conyugue;
                this.vaCreCliente.fecha_nacimiento_conyugue =  respuesta.cliente.fecha_nacimiento_conyugue;

                res.data.hijos.forEach(e => {
                    this.listHijosConyugue.push({
                        'id' : e.id,
                        'nombre': e.nombre,
                        'apellido': e.apellido,
                        'cumpleanio' : e.fecha_nacimiento
                    });
                });

                me.openCargando(true);
                this.modalShowNatural = true;
                this.actu_reg = 1;
                if(bloquear===true){
                    this.tituloModal = "Detalle del Cliente Natural";
                    this.detalle = true;
                }else{
                     this.tituloModal = "Actualizar Cliente Natural";
                     this.detalle = false;
                }

             })
             .catch(err => {
                 this.cleanVariables();
                 console.log(err);
                    if (err.response.status == 401) {
                        if (localStorage['authUser']) {
                            this.$router.push({name: 'login'})
                            location.reload();
                            localStorage.clear();
                        }
                    }
             })

        },

        setObtenerCliente2(data,bloquear){
            let me = this;

            me.crear_cliente_juridico.id                          =data.id
            me.crear_cliente_juridico.genero                          =data.genero
            me.crear_cliente_juridico.tipo_aplacamiento                          =data.tipo_aplacamiento
            me.crear_cliente_juridico.razon_social                =data.razon_social
            me.crear_cliente_juridico.ruc                         =data.numdoc
            me.crear_cliente_juridico.direccion                   =data.direccion
            me.crear_cliente_juridico.correo                      =data.email
            me.crear_cliente_juridico.id_documento                =data.documento.id
            me.crear_cliente_juridico.telefono_1                  =data.telefono
            me.crear_cliente_juridico.telefono_2                  =data.telefono_2
            me.crear_cliente_juridico.fecha_constitucion          =data.fecha_constitucion
            me.crear_cliente_juridico.id_actividad_economica      =data.idactividad_economica
            me.crear_cliente_juridico.id_referencia               =data.idreferencia
            me.crear_cliente_juridico.tipo                        =data.tipo
            me.crear_cliente_juridico.nombre_conyugue             =data.nombre_conyugue
            me.crear_cliente_juridico.apellido_conyugue           =data.apellido_conyugue
            me.crear_cliente_juridico.fecha_nacimiento_conyugue   =data.fecha_nacimiento_conyugue
            me.crear_cliente_juridico.hijos_cantidad              =data.hijos_cantidad

            me.crear_representante_legal.id                  = data.representante.id
            me.crear_representante_legal.nombre              = data.representante.nombre
            me.crear_representante_legal.apellido            = data.representante.apellido
            me.crear_representante_legal.documento           = data.representante.numdoc
            me.crear_representante_legal.id_documento        = data.representante.iddocumento
            me.crear_representante_legal.direccion           = data.representante.direccion
            me.crear_representante_legal.correo              = data.representante.email
            me.crear_representante_legal.telefono_1          = data.representante.telefono
            me.crear_representante_legal.telefono_2          = data.representante.telefono_2
            me.crear_representante_legal.fecha_nacimiento    = data.representante.fecha_nacimiento
            me.crear_representante_legal.estado_civil        = data.representante.estado_civil
            me.detalle_2 =  bloquear;

            if(data.hijos != null){

              data.hijos.forEach(e => {
                this.listHijosConyugue.push({
                    'id' : e.id,
                    'nombre': e.nombre,
                    'apellido': e.apellido,
                    'cumpleanio' : e.fecha_nacimiento
                });
            })

            }

            me.abrirModalJuridica();
            if(bloquear==true){
                me.tituloModal_juri = 'Detalle Cliente Juridico'
            }else{
                me.actu_reg_juri = 1;
                me.tituloModal_juri = 'Actualizar Cliente Juridico'
            }

        },

        setDeleteCliente(id){
            this.swalWithBootstrapButtons.fire({
                title: '¿Está seguro de eliminar el Cliente?',
                //text: "You won't be able to revert this!",
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText:  'Si, eliminar',
                cancelButtonText: 'Cancelar',
                reverseButtons: true
                }).then((result) => {

                    if(result.value){
                        var url = '/cliente/delete';
                        this.openCargando();
                        axios.post(url,{
                            'id': id,
                        })
                        .then(res => {

                             this.openCargando(true);

                            if(res.data.status){
                                this.notify(" Cliente Eliminado con éxito","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                            }else{
                                this.notify(" El cliente no se puede eliminar por que está en uso","","top","center","fas fa-exclamation-triangle","warning",' flipInX','flipOutX')
                            }
                            this.getListCliente(1,this.pag_mostrar);
                        })
                        .catch(err => {
                             this.openCargando(true);
                            if (err.response.status == 401) {
                                    this.$router.push({name: 'login'})
                                    location.reload();
                                    localStorage.clear();
                                this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                            }
                            console.error(err);
                        })
                }
            })
        },

        agregarHijosConyugue(){
            if(this.dataHijosConyugues.nombre === '' || this.dataHijosConyugues.apellido === '' || this.dataHijosConyugues.fecha_nacimiento === null ){
                this.notify(" " + 'Ingrese todos los datos del hijo a registrar',"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')
            }else{
                this.listHijosConyugue.push({
                    'id' : 0,
                    'nombre': this.dataHijosConyugues.nombre,
                    'apellido': this.dataHijosConyugues.apellido,
                    'cumpleanio' : this.dataHijosConyugues.fecha_nacimiento
                });

                this.dataHijosConyugues.nombre = '';
                this.dataHijosConyugues.apellido = '';
                this.dataHijosConyugues.fecha_nacimiento = null;
            }
        },

        calcularEdad(fecha) {
            if(fecha===null || fecha === ''){
                     return 0;
            }
            var hoy = new Date();
            var cumpleanos = new Date(fecha);
            var edad = hoy.getFullYear() - cumpleanos.getFullYear();
            var m = hoy.getMonth() - cumpleanos.getMonth();

            if (m < 0 || (m === 0 && hoy.getDate() < cumpleanos.getDate())) {
                edad--;
            }
            if(edad < 0) {edad = 0;}

            return edad;
        },

        eliminar_hijo(index){
            let me = this;
            me.listHijosConyugue.splice(index, 1);
        },

        abrirModal() {
            this.modalShow = !this.modalShow;
        },

        clearVariablesJuridico(){
            this.crear_cliente_juridico.razon_social                = '';
            this.crear_cliente_juridico.genero                = 'Masculino';
            this.crear_cliente_juridico.ruc                         = '';
            this.crear_cliente_juridico.direccion                   = '';
            this.crear_cliente_juridico.correo                      = '';
            this.crear_cliente_juridico.id_documento                = 3;
            this.crear_cliente_juridico.telefono_1                  = '';
            this.crear_cliente_juridico.telefono_2                  = '';
            this.crear_cliente_juridico.fecha_constitucion          = null;
            this.crear_cliente_juridico.id_actividad_economica      = 0;
            this.crear_cliente_juridico.id_referencia               = 0;
            this.crear_cliente_juridico.tipo_aplacamiento                        = 2;
            this.crear_cliente_juridico.tipo                        = 2;
            this.crear_cliente_juridico.nombre_conyugue             = '';
            this.crear_cliente_juridico.apellido_conyugue           = '';
            this.crear_cliente_juridico.fecha_nacimiento_conyugue   = null;
            this.crear_cliente_juridico.hijos_cantidad              = 0;

            this.crear_representante_legal.nombre              = '';
            this.crear_representante_legal.apellido            = '';
            this.crear_representante_legal.documento           = '';
            this.crear_representante_legal.id_documento        = 0;
            this.crear_representante_legal.direccion           = '';
            this.crear_representante_legal.correo              = '';
            this.crear_representante_legal.telefono_1          = '';
            this.crear_representante_legal.telefono_2          = '';
            this.crear_representante_legal.fecha_nacimiento    = null;
            this.crear_representante_legal.estado_civil        = '';

            this.listHijosConyugue = [];
            this.vaCreCliente.hijos_cantidad = 0 ;
            this.vaCreCliente.nombre_conyugue = '';
            this.vaCreCliente.apellido_conyugue = '';
            this.vaCreCliente.fecha_nacimiento_conyugue = null;
        },

        abrilModalImpotarExcelNatural(){
            let me = this;
            me.modalShowExcel = !this.modalShowExcel;
            if(me.modalShowExcel != true){
                me.excel_natural = '';
                me.uploadPercentage = 0;
                $("#file").val('');
            }
        },

        importarExcelNatural(){

            let me = this;
            let formData = new FormData();
            formData.append('file', me.excel_natural);
            this.openCargando();
            var url = '/cliente-natural/import';
            //Hacemos la peticion
            axios.post(url,formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                        onUploadProgress: function( progressEvent ) {
                            me.uploadPercentage = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ) );
                            console.log(me.uploadPercentage);
                        }.bind(me)
                    })
            .then(res => {
                this.openCargando(true);
                var respuesta = res.data;

                if(respuesta.status){
                    //me.$notie.alert(1, 'Requerimientos Importados Correctamente', 3);
                    this.notify("Clientes naturales importados correctamente","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    me.abrilModalImpotarExcelNatural();
                    this.getListCliente(1,this.pag_mostrar);
                }else{
                     this.notify("Error al importados clientes naturales ","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
               this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){
                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })

        },

        fileUploadeExcel(e){
            let me = this;
            let file_input =  e.target.files[0];
            me.excel_natural = file_input
        },

        abrilModalImpotarExcelJuridico(){
            let me = this;
            me.modalShowExcelJuridico = !this.modalShowExcelJuridico;
            if(me.modalShowExcelJuridico != true){
                me.excel_natural = '';
                $("#file_juridico").val('');
            }
        },

        importarExcelJuridico(){

            let me = this;
            let formData = new FormData();
            formData.append('file', me.excel_juridico);
            this.openCargando();
            var url = '/cliente-juridico/import';
            //Hacemos la peticion
            axios.post(url,formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
            .then(res => {
                this.openCargando(true);
                var respuesta = res.data;

                if(respuesta.status){
                    //me.$notie.alert(1, 'Requerimientos Importados Correctamente', 3);
                    this.notify("Clientes juridicos importados correctamente","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                    me.abrilModalImpotarExcelJuridico();
                    this.getListCliente(1,this.pag_mostrar);
                }else{
                     this.notify("Error al importados clientes juridicos ","","top","center","fas fa-check-circle","success",' flipInX','flipOutX')
                }

            })
            .catch(err => {
               this.openCargando(true);//Desactivamos ventana de carga de bloqueo

               for(var key in err.response.data.errors){
                this.notify(" " + err.response.data.errors[key],"","top","right","fas fa-exclamation-triangle","danger",'animated flipInX','flipOutX')

               }
               if (err.response.status == 401) {
                        this.$router.push({name: 'login'})
                        location.reload();
                        localStorage.clear();
                       this.openCargando(true);//Desactivamos ventana de carga de bloqueo
                    }
                console.error(err);
            })

        },

        fileUploadeExcelJuridico(e){
            let me = this;
            let file_input =  e.target.files[0];
            me.excel_juridico = file_input
        },

        consultarDatos: _.debounce(async function () {

            let me = this;
            let numero          = (me.modalShowJuridica) ? me.crear_cliente_juridico.ruc : me.vaCreCliente.cNumDoc;
            let tipo_documento  = (me.modalShowJuridica) ? me.crear_cliente_juridico.id_documento : me.vaCreCliente.eIdDocumento;

            if(!_.isEmpty(numero)){

                //let documento =  _.findWhere(me.aTipoDocumento, {id: tipo_documento});
                const documento = me.aTipoDocumento.filter(d => d.id == tipo_documento);
                const aux = documento[0];

                if(numero.length == aux.tamanio){

                    this.document.estado = false
                    try {
                        me.bloquar_input_natural = true
                        var url = '/clientes/informacion-api';
                        let post = {
                            'numero_documento'  : numero,
                            'documento_id'      : tipo_documento
                        }
                        let response        = await axios.post(url, post);
                        var respuesta       = response.data;

                        if(respuesta.success){
                            if(me.modalShowJuridica){
                                me.crear_cliente_juridico.razon_social          = respuesta.data.razon_social
                                me.crear_cliente_juridico.direccion             = respuesta.data.direccion
                                me.crear_cliente_juridico.fecha_constitucion    = respuesta.data.fecha_creacion
                            }else{

                                let pal = respuesta.data.razon_social.split(' ');

                                if(pal.length >= 4 ){
                                    me.vaCreCliente.cNombre                      = pal[2] + ' ' + pal[3]
                                    me.vaCreCliente.cApellido                    = pal[0] + ' ' + pal[1]
                                }else{
                                    me.vaCreCliente.cNombre                      = respuesta.data.razon_social
                                }
                                var data_c =  respuesta.data
                                me.vaCreCliente.cDireccion                   = data_c.direccion

                                this.vaCreCliente.genero                    = (data_c.genero == 'MUJER') ? 'Femenino' : 'Masculino'
                                this.vaCreCliente.fecha_nacimiento          = data_c.fechaNacimiento
                                this.vaCreCliente.estado_civil              = (data_c.estadoCivil == 'CASADO') ? 'Casado' : 'Soltero'
                            }
                            this.vaCreCliente.nombre_conyugue           = data_c.conyuge


                        }else{
                            //me.lista_errores.numero_documento = respuesta.message
                        }

                        me.bloquar_input_natural = false

                    } catch (error) {
                        me.bloquar_input_natural = false
                    }
                }else{
                    this.document =  {
                        error : 'El minimo y máximo de caracteres es de ' + aux.tamanio,
                        estado : true,
                    }
                }
            }

            }, 500),

        validarDatoApi(dato){
            if(dato == undefined){
                return ''
            }
            return dato
        }



        /* corregir cobertura deducible, al agregar no se borra la data de los inputs */
    },
    mounted() {
        this.getSelectTipoDoc();
        this.getListCliente(1,this.pag_mostrar);
        },
}
</script>

<style>

</style>

